import React from "react";
import styled from "@emotion/styled";

const InnerContainerImageGradientDiv = styled.div`
  background-image: linear-gradient(
    to bottom,
    rgba(34, 176, 252, 0.081),
    rgba(34, 176, 252, 0)
  );
  mix-blend-mode: luminosity;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  @media (max-width: 950px) {
    display: none;
  }
`;

const InnerContainerImageGradient = () => <InnerContainerImageGradientDiv />;
export default InnerContainerImageGradient;
